import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { environment } from './environments/environment'
import { ElementModule } from 'app/element.module';
import { AppModule } from 'app/app.module';

if (environment.production) {
  enableProdMode()
}
const WIDGET_TAG_NAME = 'chat-widget';

if (environment.production) {
  enableProdMode();
}

// Só faz bootstrap se ainda não estiver registrado
if (!customElements.get(WIDGET_TAG_NAME)) {
  platformBrowserDynamic()
    .bootstrapModule(ElementModule
)
    .catch(err => console.error(err));
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err))